// extracted by mini-css-extract-plugin
export var divider = "_1z-0";
export var dividerText = "_1z-1";